import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Entertainment from "./pages/Entertainment";
import MusicDownloads from "./pages/MusicDownloads";
import Recording from "./pages/Recording";
import Production from "./pages/Production";
import Navbar from "./components/Navbar";
import "./styles.css";
import { ApolloProvider ,useApolloClient} from '@apollo/client';
import client from './ApolloClient';
import Lessons from "./pages/Lessons";



const App = () => {

  
  return (
    <><ApolloProvider client={client}>
      <div>
        Powered by <a href="https://gigabout.com.au">gigabout.com.au</a> 
      </div>
      <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/entertainment" element={<Entertainment />} />
        <Route path="/music" element={<MusicDownloads />} />
        <Route path="/recording" element={<Recording />} />
        <Route path="/production" element={<Production />} />
        <Route path="/lessons" element={<Lessons />} />
        
      </Routes>
    </Router>
    <div>Powered by gigabout.com.au</div>
    </ApolloProvider>
    
    </>
    
    
  );

};

export default App;
